'use client';

import { usePathname } from 'next/navigation';
import { Breadcrumbs } from '@/components/Breadcrumbs';
import { generatePathWithExistingPrefix } from '@/utils/navigation.utils';

export const PickemsBreadcrumbs = ({ label }: { label: string }) => {
  const pathname = usePathname();

  const pickemsHref = generatePathWithExistingPrefix({
    currentPath: pathname,
    targetPath: '/pickems',
    matchGamePrefix: true,
  });

  return (
    <Breadcrumbs
      breadcrumbs={[
        { title: "Pick EM's", href: pickemsHref },
        { title: label },
      ]}
    />
  );
};
